__webpack_require__.p = "/tuktukrestaurant/";